module.exports = __webpack_public_path__ + "img/success-mb.3824b711.webp";